import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-testimonials',
  templateUrl: './testimonials.component.html',
  styleUrls: ['./testimonials.component.scss']
})
export class TestimonialsComponent implements OnInit {

  testimonials = [
    {
      clientView: 'Highly recommend Arkedge for their exceptional web development services. Their team is professional, skilled and attentive to detail. They provided clear communication throughout the project and delivered a beautiful, functional product within our timeline and budget. I look forward to working with them again in the future.',
      clientName: 'Executive Director, investment Banking, USA'
    },
    {
      clientView: 'Arkedge’s data management services are outstanding. They have a deep understanding of data governance and take a comprehensive approach to managing data. Their team is knowledgeable, organized, and efficient. They helped us streamline our data processes and provided a secure environment for our sensitive data. Their commitment to quality makes them an excellent choice for any organization in need of data management services. I highly recommend Arkedge for their expertise and professionalism.',
      clientName: 'Senior Director, Data & Analytics, major credit card company, USA'
    },
    {
      clientView: 'Partnering with Arkedge has been a great decision. They have a strong track record of delivering quality services, and their expertise has been invaluable to us. Their collaborative approach and dedication to client satisfaction make them an ideal partner. We look forward to continuing our partnership with Arkedge for years to come.',
      clientName: 'Co-Founder, Pentaknot Solutions, India'
    },
    {
      clientView: 'We were looking for a partner who could lay a fair bit of judgment and curation path to convert manual sketches into code in real-time without human involvement. Arkedge exactly understood our imagination and promptly came up with a hyper-personalized structured solution which was just a commendable job done for us.',
      clientName: 'Chief Architect, Bell Canada, Canada'
    },
    {
      clientView: 'It was a pleasure to work with Arkedge in our high-paced dynamic environment. This is the best and most professional UX company we have worked with. Their top-notch team of highly skilled designers and programmers was just amazing! Arkedge’s quick turnaround time, communication, and responsiveness has reserved a space for our future projects.',
      clientName: 'Senior IT consultant, ARM Solution, KSA'
    },
    {
      clientView: 'Arkedge has been great help to build complex data pipeline and help us to discover new revenue potentials for healthcare billing cycle.',
      clientName: 'SVP, Travelers, Texas USA'
    },
    {
      clientView: 'We found a technology partner in Arkedge to streamline our digital automation process and helped us define transformation roadmap to move system from legacy ecosystem to more adaptable microservices application architecture to scale for future needs.',
      clientName: 'Founder, CTO, Indicsoft, India'
    },
    {
      clientView: 'We were facing challenges to meet our business demand prior to automating our account payable process. Arkedge helped us to streamline our business processes and built an enterprise integration framework to automate account payable and invoice generation process that reduces our cycle from couple of weeks to few days.',
      clientName: 'Executive Vice President, Finance, top financial company, USA'
    },
    {
      clientView: 'Working with Arkedge has been a great business decision for us. We were looking to automate manual process for marketing campaign and reduce the execution cycle to few hours which were taking days leading to loss of prospective valuable customers.',
      clientName: 'Founder, CTO, Indoqubix, India'
    },
    {
      clientView: 'Arkedge offers us strong expertise in delivery management, including a milestone driven planning to roll out functional modules and provide user training to quickly onboard them on business application.',
      clientName: 'General Manager, ARB, Muscat Oman'
    },
    {
      clientView: 'Thanks to Arkedge innovative approach, traffic on our client website has increased by 120% leading to a better conversion rate. The team has supported us continuously during peak traffic and helped us achieve our business goals.',
      clientName: 'Enterprise Infrastructure PMO Leader, Texas, USA'
    },
    {
      clientView: 'We have worked with Arkedge for various successful project engagements. Their team has done exceptional work in gathering requirements, followed agile methodologies, closely worked with business stakeholders and adaptable to usually changing requirements meticulously. We are looking forward to many more engagements with them.',
      clientName: 'Head Finance & commercials, TATA Hitachi, Japan'
    },
    {
      clientView: 'Arkedge worked as our offshore technology partner to build the data engineering product for auto ingestion, tagging and classification for our thousands of documents. This helped us immensely in enriching the knowledge base repository for our medical servicing partners.',
      clientName: 'SVP Engineering, Flywire USA'
    },
    {
      clientView: 'We have a complex use case that requires an API integration framework to build merchant risk profiling pipeline before they can be onboarded. Arkedge offered us a great team with a mix of strong technical professionals and domain consultants and delivered the solution successfully.',
      clientName: 'SVP, Citi Bank, India'
    },
    {
      clientView: 'Arkedge has become a strategic partner for us as they worked with us on mission critical initiatives. Their team collaborated with us to refine our strategic roadmap and delivered critical architectural components and modules for CRM system.',
      clientName: 'Founder, Web All Solutions, India'
    },
];
  constructor() { }

  ngOnInit() {
  }

}
